/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! GhostStat Page Watch — viewer. */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  var root = document.querySelector('[data-pw="root"]');
  if (!root) return;
  var TIMER = null, DATA = null;

  function q(k) { return root.querySelector('[data-pw="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function nf(n) { n = +n || 0; return n >= 1e3 ? (n / 1e3).toFixed(1) + "k" : String(n); }
  function tone(i) { return i == null ? "#8C95A1" : i >= 65 ? "#1FA463" : i >= 40 ? "#D97706" : "#DC2626"; }
  function ago(ts) {
    if (!ts) return "";
    var d = new Date(String(ts).replace(" ", "T"));
    var s = Math.max(0, Math.round((Date.now() - d.getTime()) / 1000));
    return s < 60 ? s + "s ago" : s < 3600 ? Math.round(s / 60) + "m ago" : Math.round(s / 3600) + "h ago";
  }

  function post(body) {
    return GS.api("/plugin/page-watch/save?site=" + encodeURIComponent(GS.site),
                  { method: "POST", body: JSON.stringify(body) });
  }

  function renderLists(d) {
    [["path", "list-path"], ["referrer", "list-ref"]].forEach(function (pair) {
      var host = q(pair[1]); if (!host) return;
      var rows = (d.watches || []).filter(function (w) { return w.kind === pair[0]; });
      if (!rows.length) {
        host.innerHTML = '<div class="pwx-empty">'+TR('pagewa.f2.nothing_watched_yet')+'</div>';
        return;
      }
      host.innerHTML = rows.map(function (w) {
        return '<div class="pwx-wrow' + (w.active ? "" : " off") + '">'
          + '<span class="pwx-wdot" style="background:' + (w.live_n ? "#1FA463" : "#C7CDD6") + '"></span>'
          + '<span class="pwx-wval">' + esc(w.value) + "</span>"
          + '<span class="pwx-wn" title="' + w.live_n + ' here now, ' + w.seen_n + ' seen in the last two hours">'
          + w.live_n + " now</span>"
          + '<label class="pwx-sw" title="' + esc(TT(w.alert !== false ? 'pw.alert_tip_on' : 'pw.alert_tip_off')) + '">'
          + '<input type="checkbox" data-alert="' + w.id + '"' + (w.alert !== false ? " checked" : "")
          + (w.active ? "" : " disabled") + '><i aria-hidden="true"></i>' + esc(TT('pw.alert_me')) + '</label>'
          + '<button class="pwx-wbtn" data-toggle="' + w.id + '" title="'
          + (w.active ? TR('pagewa.p.pause_this_watch_without_deleting_it') : TT('pw.m.resume_this_watch')) + '">'
          + (w.active ? "pause" : "resume") + "</button>"
          + '<button class="pwx-wbtn pwx-wdel" data-remove="' + w.id + '" title="'+TT('pw.tip_stop')+'">remove</button>'
          + "</div>";
      }).join("");
      host.querySelectorAll("[data-toggle]").forEach(function (b) {
        b.addEventListener("click", function () { post({ op: "toggle", id: +b.getAttribute("data-toggle") }).then(load); });
      });
      host.querySelectorAll("[data-alert]").forEach(function (b) {
        b.addEventListener("change", function () {
          var on = b.checked;
          post({ op: "alert", id: +b.getAttribute("data-alert"), on: on }).then(function (r) {
            var d = (r && r.data) ? r.data : r;
            if (d && d.ok === false) { b.checked = !on; if (d.error) alert(d.error); return; }
            /* The pop-ups on every other page read the same list: refresh it now, not in 15 s. */
            if (window.GS && GS.liveWatch && GS.liveWatch.refresh) GS.liveWatch.refresh();
            load();
          }, function () { b.checked = !on; });
        });
      });
      host.querySelectorAll("[data-remove]").forEach(function (b) {
        b.addEventListener("click", function () { post({ op: "remove", id: +b.getAttribute("data-remove") }).then(load); });
      });
    });
  }

  function card(v) {
    var bits = [];
    if (v.intent != null)  bits.push("intent " + v.intent);
    if (v.friction != null) bits.push("friction " + v.friction);
    if (v.scroll != null)  bits.push(v.scroll + "% scrolled");
    if (v.dwell_s != null) bits.push(v.dwell_s + "s");
    var bot = v.is_bot || v.verdict === "likely";
    return '<button class="pwx-card' + (v.is_live ? " live" : "") + (bot ? " bot" : "") + '" data-sid="' + v.session_id + '">'
      + '<span class="pwx-c-top"><b>' + (bot ? '<span class="pwx-bot">' + esc(TT(v.is_bot ? 'pw.bot' : 'pw.likely_bot'))
          + (v.bot_score != null && !v.is_bot ? ' ' + v.bot_score : '') + '</span> ' : '') + esc(v.page || "—") + "</b>"
      + '<span class="pwx-c-when">' + (v.is_live ? "now" : ago(v.last_seen)) + "</span></span>"
      + '<span class="pwx-c-meta">' + esc(v.device || "—")
      + (v.country ? " · " + esc(v.country) : "") + " · " + v.pages + " page" + (v.pages === 1 ? "" : "s")
      + (v.persona ? " · " + esc(v.persona) : "") + "</span>"
      + '<span class="pwx-c-sig" style="color:' + tone(v.intent) + '">' + esc(bits.join(" · ") || "not scored") + "</span>"
      + "</button>";
  }

  function renderPanels(d) {
    var host = q("panels"); if (!host) return;
    var ws = (d.watches || []).filter(function (w) { return w.active; });
    if (!ws.length) { host.innerHTML = ""; return; }
    host.innerHTML = ws.map(function (w) {
      var live = w.live || [], recent = w.recent || [];
      var body = live.length
        ? '<div class="pwx-cards">' + live.map(card).join("") + "</div>"
        : '<div class="pwx-empty">' + (w.quiet && w.quiet.note
              ? esc(w.quiet.note).replace(/&amp;mdash;/g, "\u2014")
              : TR('pagewa.f2.nobody_here_right_now')) + "</div>";
      var rec = recent.length
        ? '<div class="pwx-recent"><div class="pwx-rec-h">'+TR('pagewa.g.recently')+'</div><div class="pwx-cards">'
          + recent.map(card).join("") + "</div></div>"
        : "";
      return '<div class="gs-card mb-3"' + (w.kind === "path" ? ' data-gs-page="' + esc(w.value) + '"' : "") + '><div class="gs-card-body">'
        + '<h2 class="pwx-h2"><span class="pwx-kind">' + (w.kind === "path" ? "page" : "from") + "</span>"
        + esc(w.value) + '<span class="pwx-count">' + w.live_n + " now"
        + (w.bots_n ? ' <small class="pwx-botn">+ ' + esc(TT(w.bots_n === 1 ? 'pw.bots_one' : 'pw.bots_n').replace('%n%', w.bots_n)) + '</small>' : '')
        + "</span></h2>"
        + body + rec + "</div></div>";
    }).join("");

    host.querySelectorAll("[data-sid]").forEach(function (b) {
      b.addEventListener("click", function () {
        var sid = +b.getAttribute("data-sid");
        /* Follow live (on every page via live-watch.js) shows who they are, where they are now and
           how far they scrolled, updating while it is open. The older detail panel stays as the
           fallback for when that script is not on the page. */
        if (window.GS && GS.liveWatch && GS.liveWatch.follow) GS.liveWatch.follow(sid);
        else openVisitor(sid);
      });
    });
    /* page-watch read no URL parameters at all, so "watch this page" from anywhere else in the
       product arrived as a plain page load. If the page is already watched we jump to that card;
       if it is not, the add form is pre-filled and the note says so — the useful answer to
       "watch this page" is either "already watching" or "press Add", never silence. */
    if (window.GS && GS.applyPageDeepLink) GS.applyPageDeepLink(root, {
      within: host,
      missText: 'Not watching ' + GS.dlParam("page") + ' yet \u2014 it is filled in below, press Add to start.',
      onMiss: function (v) { var i = q("in-path"); if (i && !i.value) { i.value = v; try { i.focus(); } catch (e) {} } }
    });
  }

  function findVisitor(sid) {
    var hit = null;
    (DATA && DATA.watches || []).forEach(function (w) {
      (w.live || []).concat(w.recent || []).forEach(function (v) { if (v.session_id === sid) hit = v; });
    });
    return hit;
  }

  function openVisitor(sid) {
    var v = findVisitor(sid); if (!v) return;
    var t = q("oc-title"), sub = q("oc-sub"), body = q("oc-body");
    if (t) t.textContent = TR('pagewa.g.session') + sid;
    if (sub) sub.textContent = (v.is_live ? "On the site now" : "Last seen " + ago(v.last_seen))
      + " · arrived from " + (v.referrer || "Direct");
    if (!body) return;
    function stat(k, val) { return '<div class="pwx-oc-stat"><span>' + k + "</span><b>" + val + "</b></div>"; }
    function link(base, label, why) {
      return '<a class="pwx-oc-link" href="' + base + encodeURIComponent(sid) + '" title="' + esc(why) + '">'
           + esc(label) + "<em>" + esc(why) + "</em></a>";
    }
    body.innerHTML =
      '<div class="pwx-oc-stats">'
      + stat(TR('pagewa.g.on_page'), esc(v.page || "—")) + stat(TR('pagewa.g.pages'), v.pages)
      + stat(TR('pagewa.g.intent'), v.intent == null ? "—" : v.intent)
      + stat(TR('pagewa.g.friction'), v.friction == null ? "—" : v.friction)
      + stat(TR('pagewa.g.attention'), v.attention == null ? "—" : v.attention)
      + stat(TR('pagewa.g.scrolled'), v.scroll == null ? "—" : v.scroll + "%")
      + "</div>"
      + (v.persona || v.journey
          ? '<div class="pwx-oc-sec"><h6>'+TT('pw.js.how_they_are_behaving')+'</h6><p class="pwx-oc-p">'
            + (v.persona ? "Reads as <b>" + esc(v.persona) + "</b>" : "")
            + (v.journey ? ", currently in <b>" + esc(v.journey) + "</b>" : "") + ".</p></div>"
          : "")
      + '<div class="pwx-oc-sec"><h6>'+TT('pw.js.open_this_session_in')+'</h6><div class="pwx-oc-links">'
      + link("/visitor-intelligence?session_id=", TR('pagewa.g.visitor_intelligence'), TT('pw.m.the_whole_story_for_this_visitor'))
      + link("/session-recordings?session_id=", TR('pagewa.g.session_recordings'), TT('pw.m.watch_what_they_actually_did'))
      + link("/user-flow?session_id=", TR('pagewa.g.user_flow'), TT('pw.m.the_path_they_took_through_the_sit'))
      + link("/identity-graph?session_id=", TR('pagewa.g.identity_graph'), TT('pw.m.everything_known_about_them'))
      + "</div></div>"
      + '<div class="pwx-oc-sec"><h6>'+TT('pw.js.open_this_page_in')+'</h6><div class="pwx-oc-links">'
      + '<a class="pwx-oc-link" href="/heatmaps?page=' + encodeURIComponent(v.page || "/") + '">Heatmaps'
      + "<em>'+TT('pw.js_click_scroll')+'</em></a>"
      + '<a class="pwx-oc-link" href="/content-intel?page=' + encodeURIComponent(v.page || "/") + '">Content Intelligence'
      + "<em>'+TT('pw.js.whether_this_page_is_actually_read')+'</em></a>"
      + "</div></div>";

    var el = document.getElementById("pwVisitorOc");
    if (el && window.bootstrap && bootstrap.Offcanvas) bootstrap.Offcanvas.getOrCreateInstance(el).show();
  }

  function load() {
    if (!window.GS || !GS.api || !GS.site) return;
    return GS.api("/plugin/page-watch/live?site=" + encodeURIComponent(GS.site))
      .then(function (r) {
        var d = (r && r.data) ? r.data : r;
        if (!d) return;
        DATA = d;
        var tot = q("total"); if (tot) tot.textContent = nf(d.live_total || 0);
        var dot = q("dot"); if (dot) dot.classList.toggle("on", (d.live_total || 0) > 0);
        renderLists(d); renderPanels(d);
        var note = q("note");
        if (note) note.textContent = TR('pagewa.g.live_means_seen_in_the_last') + (d.window_minutes || 5)
          + " minutes; “recently” looks back " + (d.lookback_min || 120) + "."
          + (d.has_behaviour ? "" : " Enable Visitor Intelligence for intent and friction.")
          + (d.has_depth ? "" : " Enable Content Tracking for scroll and dwell.");
      })
      .catch(function (e) {
        var note = q("note");
        if (note) note.textContent = TR('pagewa.g.could_not_load') + ((e && e.message) || "request failed") + ").";
      });
  }

  function addWatch(kind, input) {
    var v = (input.value || "").trim();
    if (!v) return;
    post({ op: "add", kind: kind, value: v }).then(function (r) {
      var d = (r && r.data) ? r.data : r;
      if (d && d.ok === false && d.error) { alert(d.error); return; }
      input.value = ""; load();
    });
  }
  var fp = q("add-path"), fr = q("add-ref");
  if (fp) fp.addEventListener("submit", function (e) { e.preventDefault(); addWatch("path", q("in-path")); });
  if (fr) fr.addEventListener("submit", function (e) { e.preventDefault(); addWatch("referrer", q("in-ref")); });

  /* Auto-refresh is opt-out: a live list that moves while you are reading it is worse than a stale one. */
  function tick() {
    var on = q("auto");
    if (TIMER) clearInterval(TIMER);
    if (on && on.checked) TIMER = setInterval(load, 15000);
  }
  var auto = q("auto");
  if (auto) auto.addEventListener("change", tick);
  document.addEventListener("visibilitychange", function () {
    if (document.hidden && TIMER) { clearInterval(TIMER); TIMER = null; }
    else tick();
  });

  document.addEventListener("gs:ready", function () { load(); tick(); }, { once: true });
  if (window.GS && GS.site) { load(); tick(); }
})();
